import { CustomMarker } from 'vue3-google-map';
import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';
import mvtCardHouseList from '@/common/components/mvtcardhouselist/mvt-cardhouselist.vue';
import format from '@/common/utilities/format';

export default {
    name: 'mvtPropertyMarker',
    inject: ['$eventBus', 'split'],
    emits: ['markerUnselect', 'markerSelected'],
    components: {
        CustomMarker,
        mvtCardProperty,
        mvtCardHouseList,
    },
    props: {
        isViewed: {
            type: Boolean,
            default: false,
        },
        isFavorite: {
            type: Boolean,
            default: false,
        },
        isHomePin: {
            type: Boolean,
            default: false,
        },
        position: Object,
        properties: Array,
        disablePopup: {
            type: Boolean,
            default: false,
        },
        map: {
            type: Object,
        },
        autoSelect: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSelected: false,
            isVisibility: false,
            positionX: -50,
            positionY: -50,
            timer: null,
        };
    },
    computed: {
        showPrice() {
            return !this.property.light && !this.property.isNearby;
        },
        property() {
            return this.properties[0];
        },
        isSingleProperty() {
            return this.properties.length === 1;
        },
        dynamicPropertyAttributes() {
            if (!this.isSingleProperty || !this.property) return null;

            return this.property
                ? {
                      showPendingBackupOffer: this.property.showPendingBackupOffer,
                      isPending: this.property.houseRealStatus === 'PENDING',
                      isForSale: this.property.houseRealStatus === 'ACTIVE',
                      isSold: this.property.isSold,
                      isNew: this.property.daysOnMovoto <= 7,
                      hasRentalPotential: false && this.property.rentalPotential,
                      isOpenHouse: !!(this.property.openHouses && this.property.openHouses.length),
                      listingByMovoto: this.property.listingByMovoto,
                      isComingSoon: this.property.isCommingSoonListing && this.property.houseRealStatus === 'ACTIVE',
                      activeUnderContract: this.property.activeUnderContract,
                      priceChange:
                          this.property.houseRealStatus === 'ACTIVE' && this.property.priceChange ? (this.property.isPriceReduced ? (this.property.daysOnMovoto >= 7 ? 'down' : null) : 'up') : null,
                  }
                : null;
        },
        formattedPrice() {
            return `$${format.friendlyPrice(this.property.price || this.property.listPrice) || ''}`;
        },
        dynamicSubtext() {
            if (this.dynamicPropertyAttributes) {
                const { showPendingBackupOffer, isNew, isPending, activeUnderContract, isSold } = this.dynamicPropertyAttributes;
                if (isSold) {
                    return 'Sold';
                } else if (isPending) {
                    if (showPendingBackupOffer) {
                        return this.property.listingStatusDisplayName;
                    }
                    return activeUnderContract ? 'Contract' : 'Pending';
                } else if (isNew) {
                    return 'New';
                }
            }
            return null;
        },
        dynamicClass() {
            let className = '';
            if (!this.showPrice) {
                className += ' mini';
            } else if (this.isHomePin) {
                className += ' home';
            } else if (this.dynamicPropertyAttributes) {
                const { isNew, isPending, isSold } = this.dynamicPropertyAttributes;
                if (isSold) {
                    className += ' sold';
                } else if (isPending) {
                    className += ' pending';
                } else if (isNew) {
                    className += ' new';
                }
            }
            if (this.isSingleProperty) {
                if (this.isFavorite) {
                    className += ' favorite';
                }
                if (this.isViewed) {
                    className += ' viewed';
                }
            }
            return className;
        },
        dynamicIcon() {
            if (this.isHomePin) {
                switch (this.property.propertyType) {
                    case 'SINGLE_FAMILY_HOUSE':
                        return 'icon-pin-single';
                    case 'CONDO':
                        return 'icon-pin-condo';
                    case 'MULTI_FAMILY':
                        return 'icon-pin-multi';
                    case 'MOBILE':
                        return 'icon-pin-mobile';
                    case 'LAND':
                        return 'icon-pin-land';
                    case 'OTHER':
                    case 'COMMERCIAL':
                        return 'icon-pin-other';
                    default:
                        return 'icon-pin-home';
                }
            } else if (this.dynamicPropertyAttributes) {
                const { isComingSoon, isOpenHouse, priceChange, listingByMovoto, hasRentalPotential } = this.dynamicPropertyAttributes;
                if (isComingSoon) {
                    return 'icon-clock';
                } else if (isOpenHouse) {
                    return 'icon-calendar';
                } else if (priceChange) {
                    return `icon-trend-${priceChange}`;
                } else if (listingByMovoto) {
                    return 'icon-logo-m';
                } else if (hasRentalPotential) {
                    return 'icon-money';
                }
            }
            return null;
        },
    },
    methods: {
        setPosition() {
            if (!this.disablePopup) {
                this.positionX = -50;
                this.positionY = -50;
                this.$nextTick(() => {
                    let card = this.$refs.cardRef;
                    let container = card.closest('.mvt-newmap');
                    let containerRect = container.getBoundingClientRect();
                    let cardRect = card.getBoundingClientRect();
                    let cardWidth = cardRect.width;
                    let cardHeight = cardRect.height;
                    let pinRect = this.$refs.markerRef.getBoundingClientRect();
                    let x;
                    let y;

                    if (pinRect.left - containerRect.left < cardWidth / 2) {
                        x = -50 + ((cardWidth / 2 - (pinRect.left - containerRect.left)) * 100) / cardWidth;
                    } else if (containerRect.right - pinRect.right < cardWidth / 2) {
                        x = -50 - ((cardWidth / 2 + (pinRect.right - containerRect.right) - pinRect.width) * 100) / cardWidth;
                    } else {
                        x = -50;
                    }

                    if (containerRect.bottom - cardRect.bottom < cardHeight / 2) {
                        y = -100 - ((pinRect.height + 5) / cardHeight) * 100;
                    } else {
                        y = ((pinRect.height + 5) / cardHeight) * 100;
                    }
                    this.positionX = x;
                    this.positionY = y;
                    this.isVisibility = true;
                });
            }
        },
        setSelected(value) {
            if (value !== undefined) {
                this.isSelected = value;
            } else {
                this.isSelected = !this.isSelected;
            }

            if (this.isSelected) {
                // Add event listener when the card becomes visible
                document.addEventListener('click', this.handleClickOutside);
            } else {
                // Remove event listener when the card is hidden
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        handleClickOutside(event) {
            // Check if the click is outside the dropdown
            if (this.$refs.markerRef && !this.$refs.markerRef.contains(event.target)) {
                this.isSelected = false;
                // Remove event listener after hiding the dropdown
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        disableMapScroll() {
            this.$el.focus();
            this.map.setOptions({ scrollwheel: false, draggable: false });
        },
        enableMapScroll() {
            this.map.setOptions({ scrollwheel: true, draggable: true });
        },
    },
    watch: {
        isSelected(isSelected) {
            if (isSelected) {
                this.$emit('markerSelected', this.properties, 'property');
                this.setPosition();
            } else {
                this.$emit('markerUnselect', this.properties, 'property');
            }
        },
        autoSelect(newval) {
            if (newval) {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.setSelected(true);
                }, 100);
            }
        },
    },
    mounted() {
        if (this.autoSelect) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setSelected(true);
            }, 100);
        }
    },
    beforeUnmount() {
        // Remove event listener to avoid memory leaks
        document.removeEventListener('click', this.handleClickOutside);
    },
};
